import React from "react";

import { cn } from "../../../lib/utils";
import { ButtonLabelLoader } from "../../custom/button-label-loader";
import { buttonVariants } from "../button";
import { useFormContext } from "./form-context";

export interface SubmitButtonProps {
  label: string;
  className?: string;
}

export default function SubmitButton({ label, className }: SubmitButtonProps) {
  const form = useFormContext();
  return (
    <form.Subscribe selector={(state) => state.isSubmitting}>
      {(isSubmitting) => (
        <button className={cn(buttonVariants({}), className)} disabled={isSubmitting}>
          <ButtonLabelLoader isPending={isSubmitting} label={label} />
        </button>
      )}
    </form.Subscribe>
  );
}
